@if (inventoryItem && !inventoryItem.assignee) {
  <p-button-pure [icon]="'none'" [underline]="true" (click)="open = true">Assign</p-button-pure>
}

<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">Assign inventory item</p-heading>

  <form class="form" [formGroup]="form" [id]="formId" (ngSubmit)="submit()">
    <p-select-wrapper
      *ngrxLet="form.controls.assigneeId as control"
      [filter]="true"
      [label]="'Assign item to member: '"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
    >
      <select [attr.required]="true" [formControl]="control">
        <option *ngFor="let user of users$ | async; trackBy: trackUser" [value]="user.id">
          {{ user.firstName }} {{ user.lastName }}
        </option>
      </select>
    </p-select-wrapper>
  </form>

  <p-button-group slot="footer">
    <p-button [form]="formId" [loading]="(submitting$ | async) ?? false" [type]="'submit'">
      Assign
    </p-button>
    <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
      Close
    </p-button>
  </p-button-group>
</p-modal>
